module.exports = __webpack_public_path__ + "static/media/livingitup.b18058ed.svg";